import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from './Popover';

export default class PopoverTrigger extends Component {
  static propTypes = {
    triggerId: PropTypes.string,
    popoverContent: PropTypes.object,
    hover: PropTypes.bool,
  };

  static defaultProps = {
    inPlace: false,
    hover: false,
    triggerId: null,
  }

  constructor(props) {
    super(props)

    this.triggerRef = React.createRef();
    this.state = {
      open: false,
    };
  }

  open = () => {
    this.setState({ open: true });
  }

  handleMouseEnter = e => {
    if (this.props.hover) {
      this.open()
    }
  }

  handleMouseLeave = e => {
    if (this.props.hover) {
      this.setState({ open: false });
    }
  }

  handleClick = (e) => {
    if (this.props.hover) {
      return;
    }
    if (this.triggerRef.current.contains(e.target) && !this.state.open) {
      this.open();
    }
  }

  handleClose = (e) => {
    if (this.props.hover) {
      return;
    }
    if (!this.triggerRef.current.contains(e.target) && this.state.open) {
      this.setState({ open: false });
    }
  }

  render() {
    const { triggerId, popoverContent, ...otherProps } = this.props;
    return (
      <div ref={this.triggerRef} onClick={this.handleClick} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} id={triggerId} className="u-cursor-pointer">
        {this.props.children}
        <Popover visible={this.state.open} onClickOutside={this.handleClose} {...otherProps}>
          { popoverContent }
        </Popover>
      </div>
    );
  }
}
